const authNotice = (document.getElementsByName('auth-notice')[0] as any).value;
const authErrorStatus = (document.getElementsByName('auth-error-status')[0] as any).value;
const authErrorCode = (document.getElementsByName('auth-error-code')[0] as any).value;
const authErrorMsg = (document.getElementsByName('auth-error-message')[0] as any).value;
const adminOneTitle = (document.getElementsByName('admin-one-title')[0] as any).value;

export const EmbeddedData = Object.freeze({
    authNotice: authNotice !== '' ? authNotice : undefined,
    authErrorStatus: parseInt(authErrorStatus),
    authErrorCode: authErrorCode !== '' ? authErrorCode : undefined,
    authErrorMsg: authErrorMsg !== '' ? authErrorMsg : undefined,
    adminOneTitle: adminOneTitle !== '' ? adminOneTitle : undefined,
});
